import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import classnames from 'classnames'
import { Button, Modal } from 'lp-components'
import { PATH, makeMembershipIdPath } from 'config'
import {
  formatUSMonthDayYearDate,
  isAutoRenewDisabled,
  parseISODate,
} from 'utils'

const propTypes = {
  autorenews: PropTypes.bool.isRequired,
  handleCancelAutoRenewal: PropTypes.func.isRequired,
  membershipExpirationDate: PropTypes.string.isRequired,
  membershipId: PropTypes.string.isRequired,
}

function AutoRenewalToggle({
  autorenews,
  handleCancelAutoRenewal,
  membershipExpirationDate: expirationDateString,
  membershipId,
}) {
  const history = useHistory()
  const [showModal, setShowModal] = useState(false)
  const [isCancelling, setIsCancelling] = useState(false)

  const isDisabled = isAutoRenewDisabled(expirationDateString)
  const membershipExpirationDate = parseISODate(expirationDateString)

  const handleToggle = (event) => {
    if (event.target.checked) {
      history.push(
        makeMembershipIdPath(
          membershipId,
          PATH.BILLING,
          PATH.AUTO_RENEW_ENROLLMENT,
        ),
      )
    } else {
      setShowModal(true)
    }
  }

  const handleUnenroll = async () => {
    setIsCancelling(true)
    await handleCancelAutoRenewal({ membershipId })
    setShowModal(false)
  }

  return (
    <>
      <div className="actions">
        <div className="switch-wrapper">
          <p>You are currently {autorenews === false && 'not'} enrolled</p>
          <label className="switch" htmlFor="autoRenewSwitch">
            <input
              id="autoRenewSwitch"
              aria-label="Enable auto-renew option"
              type="checkbox"
              checked={autorenews}
              disabled={isDisabled}
              onChange={handleToggle}
            />
            <span
              className={classnames('slider round', {
                checked: autorenews,
                locked: isDisabled,
              })}
            ></span>
          </label>
        </div>
      </div>

      {showModal && (
        <Modal onClose={() => setShowModal(false)}>
          <h2>Are you sure you want to unenroll in Auto Renewal?</h2>
          <p>
            Auto Renewal helps gives peace of mind.{' '}
            <strong>
              By unenrolling, you'll need to make sure to log back into your
              account before{' '}
              {formatUSMonthDayYearDate(membershipExpirationDate)} or your
              membership will expire.
            </strong>
          </p>
          <div className="button-group">
            <Button
              onClick={() => setShowModal(false)}
              className="button-primary-outline"
              disabled={isCancelling}
            >
              Cancel
            </Button>
            <Button
              onClick={handleUnenroll}
              className="button-warn"
              disabled={isCancelling}
            >
              {isCancelling ? 'Cancelling...' : 'Yes, Unenroll'}
            </Button>
          </div>
        </Modal>
      )}
    </>
  )
}

AutoRenewalToggle.propTypes = propTypes

export default AutoRenewalToggle
